import { render, staticRenderFns } from "./kdVinInfoDialog.vue?vue&type=template&id=4a0f31a5"
import script from "./kdVinInfoDialog.vue?vue&type=script&lang=js"
export * from "./kdVinInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports